import API from '../index';
import { Order } from '../../types/common';

const removeCoupon = async (orderId: string, couponCode: string): Promise<Order> => {
  const data: Order = await API.delete(`/orders/${orderId}/coupon`, { coupon: couponCode });
  return data;
};

export default removeCoupon;
